import {
  Component,
  forwardRef,
  OnInit,
  viewChild,
  DestroyRef,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseControl } from '../base-control';
import { AppFormFieldControl } from '../../form-field/form-field-control/form-field-control';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SlideToggleComponent),
      multi: true
    },
    {
      provide: AppFormFieldControl,
      useExisting: forwardRef(() => SlideToggleComponent)
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule]
})
export class SlideToggleComponent
  extends BaseControl<boolean>
  implements OnInit
{
  #destroyRef = inject(DestroyRef);
  readonly ngControl = viewChild(NgControl);

  ngOnInit() {
    this.ngControl()
      .statusChanges.pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => this.stateChanges.next());
  }
}
